import moment from 'moment';
import DashboardClock from '../Dashboard/DashboardClock';

const UserCard = () => {
  return (
    <div
      className="card dead_dash m-b-20 enhanced-card"
      style={{ color: 'rgba(13, 71, 161, 0.8)' }}
    >
      <div className="border_class">
        <h5 className="dash-card-title font-20 ml-3">Timezone</h5>
      </div>
      <div className="d-flex justify-content-center align-items-center card-body bg-white">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <DashboardClock />
          <h4 className=" text-muted mt-4">{moment.tz.guess()}</h4>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
